import {
  NavigationGuard,
  Route,
} from 'vue-router';
import {
  Store,
} from 'vuex';

import {
  NavigationGuardNext,
} from '@/store/types';


export const updateProfile = (store: Store<{}>): NavigationGuard => (
  to: Route,
  from: Route,
  next: NavigationGuardNext,
): void => {
  const isAuthPage = [
    'login',
    'register',
    'restore-password',
  ].includes(location.pathname.replace('/', ''));
  const isAuthenticated = store.getters['auth/isAuthenticated'];
  const profileLoaded = store.getters['profile/isLoaded'];

  if (!isAuthPage && isAuthenticated && !profileLoaded) {
    store.dispatch('profile/load');
  }

  next();
};
